export default __webpack_public_path__ + "static/media/Icon metro-warning.89b95cb4.svg";